const GLOBAL_FOOTER = {
    TERMS_OF_USE: 'https://boost.com.au/pages/terms-of-use',
    PRIVACY: 'https://boost.com.au/pages/privacy-policy',
    HELP_AND_SUPPORT: 'https://boost.com.au/pages/help-topics',
    CRITICAL_INFORMATION_SUMMARY: 'https://boost.com.au/pages/important-information-boost-mobile'
};

export default GLOBAL_FOOTER;

